// src/pages/subscription/DiscountEditPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Discounts are edited
// inline on DiscountDetailPage now (DiscountFormDialog reused for edit) —
// there is no edit route/mode, per docs/ux/14-forms.md. This route just
// sends people to the detail page.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const DiscountEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/subscriptions/discounts/${id}` : '/subscriptions/discounts', { replace: true });
  }, [navigate, id]);
  return null;
};

export default DiscountEditPage;
